import React from "react";

import { Route } from "react-router-dom";
import { RetrospectiveMain } from "../../../components/retrospective/RetrospectiveMain";
import { RetroWelcome } from "../../../screens/retrospective/RetroWelcome";
import { RETRO_PAGES } from "components/retrospective/RetrospectiveData";
import { RetroCO2 } from "screens/retrospective/RetroCO2";
import { RetroEnergy } from "screens/retrospective/RetroEnergy";
import { RetroAutomation } from "screens/retrospective/RetroAutomation";
import { RetroImpact } from "screens/retrospective/RetroImpact";
import { RetroODS } from "screens/retrospective/RetroODS";
import { RetroConclusion } from "screens/retrospective/RetroConclusion";

export const RetrospectiveRouter = () => {
  return (
    <RetrospectiveMain>
      <Route path={RETRO_PAGES.WELCOME} component={RetroWelcome} />
      <Route path={RETRO_PAGES.CO2} component={RetroCO2} />
      <Route path={RETRO_PAGES.RENEWABLES} component={RetroEnergy} />
      <Route path={RETRO_PAGES.AUTOMATIONS} component={RetroAutomation} />
      <Route path={RETRO_PAGES.ENVIRONMENTAL} component={RetroImpact} />
      <Route path={RETRO_PAGES.ODS} component={RetroODS} />
      <Route path={RETRO_PAGES.IMPACT} component={RetroConclusion} />
    </RetrospectiveMain>
  );
};
